import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ColorService } from '@zaoblako/web/core/services/color.service';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  standalone: true,
  selector: 'crm-status-label',
  templateUrl: 'status-label.component.html',
  imports: [CommonModule, TooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusLabelComponent {
  @Input() public styleClass: string;
  @Input() public name = '-';

  @Input() public isTruncateStatus = true;
  @Input() public isShowTooltip = true;

  public backgroundColor = '#808080';
  public textColor = '#ffffff';

  public constructor(private readonly colorService: ColorService) {}

  @Input()
  public set color(color: string) {
    this.backgroundColor = color ?? '#808080';
    this.textColor = this.colorService.isColorLight(this.backgroundColor) ? '#000000' : '#ffffff';
  }
}
